import React, { useEffect, useState } from 'react';
import { GetFileArchiveListForView } from '../Adapters/GetFileArchiveListForView';

export default function useGetFileArchiveListForView() {
  const [fileAcrhiveList, setFileArchiveList] =
    useState(null);
  useEffect(() => {
    GetFileArchiveListForView(setFileArchiveList);
  }, []);

  return fileAcrhiveList;
}
